import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgInject } from '@df/ng/ng-inject';
import { Basket } from '@df/session/api/basket/basket';
import { AutoSizeInputDirective } from '@df/ui/form/auto-size-input.directive';
import { QtySelectComponentDef } from '@df/ui/form/qty-select.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../catalog/model/product/product.decorator';
@Component({
    selector: 'item-qty',
    templateUrl: './item-qty.html',
    styleUrls: ['./item-qty.scss'],
    standalone: true,
    imports: [NgClass, TranslationModule, FormsModule, AutoSizeInputDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemQtyComponent extends QtySelectComponentDef implements OnInit {
    @Input()
    itemId: number;
    @Input()
    product: LocalProduct;
    @Input()
    bigVariant?: boolean;
    @Input()
    isParent?: boolean;
    @Input()
    canUseIncrementAsMinQty = false;

    @NgInject(Basket)
    private basket: Basket;
    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.basket.subscribe(() => this.detectChanges()));
    }
    get inputWidth(): string {
        return this.bigVariant ? '35' : '18.2';
    }
    get increment(): number {
        return this.product?.increment || 1;
    }
    get minQty(): number {
        if (this.min !== undefined) {
            return this.min;
        }
        if (this.canUseIncrementAsMinQty && this.product.canUseIncrementAsMinQty()) {
            return this.increment;
        }
        return this.product?.minQty || 1;
    }
    override more(): void {
        if (this.canMore()) {
            this.model = this.product.validateQty(<number>this.model + this.increment, this.canUseIncrementAsMinQty);
            this.detectChanges();
        }
    }
    override less(): void {
        if (this.canLess()) {
            const result = (this.model as number) - this.increment;
            this.model = result ? this.product.validateQty(result, this.canUseIncrementAsMinQty) : 0;
            this.detectChanges();
        }
    }
    override canLess(): boolean {
        if (super.canLess()) {
            return this.minQty < this._model;
        }
        return false;
    }
}
